class ContentHighlights extends window.PURELEI.CustomElement() {
    connectedCallback () {
        super.connectedCallback()
    }

    setupListeners () {
        super.setupListeners()

        this.handleTrigger = this.handleTrigger.bind(this)

        this.els.trigger?.elements.forEach((triggerEl) => {
            this.listeners.add(triggerEl, 'click', this.handleTrigger)
            this.listeners.add(triggerEl, 'touchstart', this.handleTrigger)
        })
    }

    handleTrigger (event) {
        this.els.trigger.elements.forEach((triggerEl) => {
            triggerEl.setAttribute(
                'aria-pressed',
                triggerEl.dataset.index === event.target.dataset.index,
            )
        })

        const els = [
            this.els.media.elements,
            this.els.text.elements,
            this.els.link.elements,
        ]

        els.forEach((el) => {
            el.forEach((el) => {
                el.setAttribute(
                    'aria-hidden',
                    el.dataset.index !== event.target.dataset.index,
                )
            })
        })
    }
}

if (!customElements.get('content-highlights')) {
    customElements.define('content-highlights', ContentHighlights)
}
